import React, { useState } from 'react';
import './Dates.scss';
import Calendar from 'react-calendar';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import dayjs from 'dayjs';

function Dates({
	// irrevocableDate,
	// setIrrevocableDate,
	closingDate,
	setClosingDate,
	setDisable,
	disable,
}) {
	const [open, setOpen] = useState('closing');
	const [preselectIrrevocableDate, setPreselectIrrevocableDate] = useState(
		new Date()
	);
	const [preselectClosingDate, setPreselectClosingDate] = useState(new Date());
	const [disableSelect, setDisableSelect] = useState(true);

	// const handleDoneIrrevocable = () => {
	// 	setIrrevocableDate(preselectIrrevocableDate);
	// 	setOpen('closing');
	// 	setDisableSelect(false);
	// };
	const handleDoneClosing = () => {
		setClosingDate(preselectClosingDate);
		setOpen('closeClosing');
		setDisable({ ...disable, dates: false });
	};

	return (
		<div className='doc_card dates_wrapper'>
			{/* {open === 'irrevocable' ? (
				<div className='inner_card'>
					<div className='card_title'>Irrevocable Date</div>
					<Calendar
						onChange={setPreselectIrrevocableDate}
						value={preselectIrrevocableDate}
						className='new-react-calendar'
						minDate={new Date()}
						showFixedNumberOfWeeks={true}
					/>
					<div className='done_date_btn'>
						<button onClick={handleDoneIrrevocable}>Done</button>
					</div>
				</div>
			) : (
				<div className='inner_card_init'>
					<div className='card_title'>Irrevocable Date</div>
					<div className='selected_date'>
						{dayjs(irrevocableDate).format('DD MMM YYYY')}
					</div>
					<button className='slt_btn' onClick={() => setOpen('irrevocable')}>
						Select
					</button>
				</div>
			)} */}
			{open === 'closing' ? (
				<div className='inner_card'>
					<div className='card_title'>Closing Date</div>
					<Calendar
						onChange={setPreselectClosingDate}
						value={preselectClosingDate}
						className='new-react-calendar'
						minDate={new Date()}
						showFixedNumberOfWeeks={true}
					/>
					<div className='done_date_btn'>
						<button onClick={handleDoneClosing}>Done</button>
					</div>
				</div>
			) : (
				(open === 'closeClosing' || open === 'irrevocable') && (
					<div className='inner_card_init'>
						<div className='card_title'>Closing Date</div>
						<div className='selected_date'>
							{dayjs(closingDate).format('DD MMM YYYY')}
						</div>
						<button
							className='slt_btn'
							onClick={() => setOpen('closing')}
							disabled={disableSelect}
						>
							Select
						</button>
					</div>
				)
			)}
		</div>
	);
}

export default Dates;
